import { useState } from 'react';
import { RouterProvider } from 'react-router';
import { ThemeProvider } from '@/components/theme';
import { ToastProvider } from '@/components/ui';
import { AuthProvider } from '@/lib/auth/AuthProvider';
import { createAppRouter } from './router';

export function App() {
  const [router] = useState(createAppRouter);
  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}
